import AvailableUpdateModal from '@features/available-update-modal/available-update-modal';
export default AvailableUpdateModal;
